const degrees = ['1º', '2º', '3º']
export const FAMILY_HISTORY = [
  {
    key: 'doenca_reumatologia',
    name: 'Alguém na família tem doença reumatológica ou auto-imune?',
    options: {
      textArea: [
        {
          key: 'qual_doenca',
          name: 'Qual doença auto-imune na família?',
          placeholder: 'Descreva as doenças auto-imune na família.',
        },
        {
          key: 'tratamentos',
          name: 'Quais tratamentos foram feitos?',
          placeholder: 'Descreva os tratamentos feitos pelos familiares.',
        },
      ],
    },
  },
  {
    key: 'urticaria',
    name: 'Algum familiar tem urticária?',
    options: { radioOptions: degrees },
  },
  {
    key: 'angioedema',
    name: 'Algum familiar tem angioedema?',
    options: { radioOptions: degrees },
  },
]
